import AnimationComponent from '../../../Component/Animation';
import Interactable from '../../../Component/Interactable';
import CardComponent from '../../../Component/Level/Card';
import Renderable from '../../../Component/Renderable';
import TransformComponent from '../../../Component/Transform';
import Game from '../../../Game';
import GameObject from '../../../GameObject/GameObject';
import Point from '../../../Utility/Point';
import Sprite from '../../Sprite';

export default class BaseCard extends GameObject {
    public score: number = 0;

    protected onCreate(params: any): void {
        this.addComponent<TransformComponent>(TransformComponent, params);

        this.addComponent<Renderable>(Renderable, params);

        this.addComponent<CardComponent>(CardComponent, params);

        this.addComponent<Interactable>(Interactable);

        this.addComponent<AnimationComponent>(AnimationComponent, {
            playOnStart: false,
        });

        const cardBackSprite = GameObject.Instantiate(Sprite, {
            visible: !params.faceUp,
            name: 'cardBackSprite',
            texture:
                params.cardBackTexture ||
                Game.state.getState().playerState.backcard ||
                'backcard_1',
            anchor: new Point(0.5, 0.5),
        });

        const cardFrontSprite = GameObject.Instantiate(Sprite, {
            visible: params.faceUp,
            name: 'cardFrontSprite',
            texture: params.cardFrontTexture || 'backcard_2',
            anchor: new Point(0.5, 0.5),
        });

        this.addChild(cardBackSprite);

        this.addChild(cardFrontSprite);
    }
}
